import React from "react";
import ReactDOM from "react-dom";
import "./css/index.css";
import App from "./App";

ReactDOM.render(<div className="App"><App /></div>, document.getElementById("root"));
